/**
 *
 * Wrapper for StyledSelect when inlineSearch is true
 *
 */

import ButtonBase from '@material-ui/core/ButtonBase';
import PropTypes from 'prop-types';
import React, { useCallback, useRef } from 'react';

import useAnchorState from '../../../hooks/useAnchorState';
import useOnClickOutside from '../../../hooks/useOnClickOutside';
import ArrowDownIcon from '../../../images/arrow-down.svg';
import StyledSelect from './index';
import { inlineSearchSelectWrapperStyles as useStyles } from './styles';

const InlineSearchSelectWrapper = ({ anchorOrigin, isTargetDisabled, menuPlacement, showArrow, target, ...props }) => {
  const dropdownRef = useRef();
  const { anchorEl, toggle, handleClose } = useAnchorState();

  const classes = useStyles({
    anchorOrigin,
    isOpen: props.anchorState ? !!props.anchorState.anchorEl : !!anchorEl,
    menuPlacement,
  });

  const handleOutsideClick = useCallback(() => {
    if (props.anchorState) {
      props.anchorState.handleClose();
    } else handleClose();
  }, [handleClose, props.anchorState]);

  useOnClickOutside(dropdownRef, handleOutsideClick, props.clickOutsideRoot);

  const handleOnChange = selectedOption => {
    props.onChange(selectedOption);
    if (props.anchorState) {
      props.anchorState.handleClose();
    } else {
      handleClose();
    }
  };

  const showSelect = props.anchorState ? !!props.anchorState.anchorEl : !!anchorEl;
  return (
    <div ref={dropdownRef} className={classes.container}>
      <ButtonBase
        className={classes.target}
        disabled={isTargetDisabled}
        onClick={props.anchorState ? props.anchorState.toggle : toggle}
      >
        {target}
        {!isTargetDisabled && showArrow && <img alt="arrow-icon" className={classes.arrowIcon} src={ArrowDownIcon} />}
      </ButtonBase>
      {showSelect && (
        <div className={classes.styledSelect}>
          <StyledSelect {...props} onChange={handleOnChange} />
        </div>
      )}
    </div>
  );
};

InlineSearchSelectWrapper.propTypes = {
  anchorOrigin: PropTypes.number,
  anchorState: PropTypes.object,
  clickOutsideRoot: PropTypes.instanceOf(Element),
  isTargetDisabled: PropTypes.bool,
  menuPlacement: PropTypes.oneOf(['auto', 'bottom', 'top']),
  onChange: PropTypes.func.isRequired,
  showArrow: PropTypes.bool,
  target: PropTypes.node.isRequired,
};

InlineSearchSelectWrapper.defaultProps = {
  isTargetDisabled: false,
  showArrow: false,
};

export default InlineSearchSelectWrapper;
